// contact service
export default {
    install: (Vue) => {
      //private
      const route = process.env.VUE_APP_API_BASE_URL + '/api/';
  
      //public
      Vue.$choiceService = {
        find(choiceEntityName, params) {
          return Vue.axios.get(`${route}${choiceEntityName}`, {
            params: params
          }).then(response => {
            if (choiceEntityName === 'service-choices' && response.data && response.data.data) {
              response.data.data.sort((a, b) => {
                const nameA = a.attributes?.name || '';
                const nameB = b.attributes?.name || '';
                return nameA.localeCompare(nameB);
              });
            }
            return response;
          });
        }
      };
    }
  };
//   //example of use
//   var grants = await Vue.$grantService.find({
//     name: 'test'
//   });